import Request from './request';
import * as query from "@arcgis/core/rest/query";
import Query from "@arcgis/core/rest/support/Query";
import * as projection from "@arcgis/core/geometry/projection";
import SpatialReference from "@arcgis/core/geometry/SpatialReference";
import * as geometryJsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import { getAppConfig, getAttributeServiceUrl, getNifcToken } from '../utils/ReduxHelper';

const UserBookmarksService = {
  getBookmarksByUser: function(userId) {
    try
    {
      const queryObject = new Query({
        where: `(UsersJoinID = ${userId})`,
        outFields: "*",
        returnGeometry: true,
        orderByFields: "SequenceNumber"
    });

    const rootServiceUrl = getAttributeServiceUrl();
    const config = getAppConfig();

    return query.executeQueryJSON(rootServiceUrl + "/" + config.userBookmarks[config.env].layerId, queryObject).then(results => {
      let userItems = [];
      if(results && results.features) {
        userItems = results.features;
      } 
      return userItems;
    });
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  getBookmarksByNamesAndUser: function(userId, names) {
    try
    {
      const rootServiceUrl = getAttributeServiceUrl();
      const config = getAppConfig();

      let innerWhereArray = [];
      names.forEach((name) => {
        innerWhereArray.push("Name = '" + name + "'");
      })
      if(innerWhereArray.length !== 0){
        const nameWhereClause = innerWhereArray.join(" OR ");
        const queryObject = new Query({
          where: "((" + nameWhereClause + ") AND (UsersJoinID = '" + userId + "'))",
          outFields: "*",
          returnGeometry: true,
          orderByFields: "SequenceNumber"
        });

        return query.executeQueryJSON(rootServiceUrl + "/" + config.userBookmarks[config.env].layerId, queryObject).then(results => {
          let userItems = [];
          if(results && results.features) {
            userItems = results.features;
          } 
          return userItems;
        });
      }
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  addBookmark: function (attributes) {
    try
    {
      const rootServiceUrl = getAttributeServiceUrl();
      const config = getAppConfig();
      const nifcToken = getNifcToken();
      return new Promise((resolve, reject) => {
        projection.load().then(function () {
          const feature =
          {
              attributes: attributes
          };
          new Request().makeRequest({
              url: rootServiceUrl + "/" + config.userBookmarks[config.env].layerId + "/addFeatures",
              method: 'post',
              data: {
                  f: 'json',
                  token: nifcToken,
                  features: JSON.stringify([feature])
              }
          }).then(
              resp => {
                  resolve(resp)
              },
              error => {
                reject(error)
              }
          );
        });
      });
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  updateBookmark: function (attributes) {
    try
    {
      const rootServiceUrl = getAttributeServiceUrl();
      const config = getAppConfig();
      const nifcToken = getNifcToken();
      return new Promise((resolve, reject) => {
        projection.load().then(function () {
          const feature =
          {
              attributes: attributes
          };
  
          new Request().makeRequest({
              url: rootServiceUrl + "/" + config.userBookmarks[config.env].layerId + "/updateFeatures",
              method: 'post',
              data: {
                  f: 'json',
                  token: nifcToken,
                  features: JSON.stringify([feature])
              }
          }).then(
              resp => {
                  resolve(resp)
              },
              error => {
                reject(error)
              }
          );
        });
      });
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  updateSequenceNumber: function(bookmarkList){
    try
    {
      const rootServiceUrl = getAttributeServiceUrl();
      const config = getAppConfig();
      const nifcToken = getNifcToken();
      return new Promise((resolve, reject) => {
        new Request().makeRequest({
            url: rootServiceUrl + "/" + config.userBookmarks[config.env].layerId + "/updateFeatures",
            method: 'post',
            data: {
                f: 'json',
                token: nifcToken,
                features: JSON.stringify(bookmarkList)
            }
        }).then(
            resp => {
                resolve(resp);
            },
            error => {
              reject(error)
            }
        );
      });
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  deleteBookmark: function (objectID) {   
    try
    {
      const rootServiceUrl = getAttributeServiceUrl();
      const config = getAppConfig();
      const nifcToken = getNifcToken();
      return new Promise((resolve, reject) => {
        const whereClause = `(OBJECTID = ${objectID})`
          new Request().makeRequest({
              url: rootServiceUrl + "/" + config.userBookmarks[config.env].layerId + "/deleteFeatures",
              method: 'post',
              data: {
                  f: 'json',
                  token: nifcToken,
                  where: whereClause
              }
          }).then(
              resp => {
                  resolve(resp)
              },
              error => {
                reject(error)
              }
          );
          
      });
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  deleteBookmarkByName: function (userId, name) {
    try
    {
      const rootServiceUrl = getAttributeServiceUrl();
      const config = getAppConfig();
      const nifcToken = getNifcToken();
      return new Promise((resolve, reject) => {
        const whereClause = `((UsersJoinID = ${userId}) AND (Name = '${name}'))`
        new Request().makeRequest({
          url: rootServiceUrl + "/" + config.userBookmarks[config.env].layerId + "/deleteFeatures",
          method: 'post',
          data: {
              f: 'json',
              token: nifcToken,
              where: whereClause
          }
      }).then(
          resp => {
              resolve(resp)
          },
          error => {
            reject(error)
          }
      );
  
      });
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
};

export default UserBookmarksService;